import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { AISettings } from 'src/components/UserSettings/AISettings';
import { GeneralSettings } from 'src/components/UserSettings/GeneralSettings';
import { useTitle } from 'src/hooks';

export const UserSettings: React.FC = (props) => {
    let match = useRouteMatch();
    useTitle('Settings');

    return (
        <Switch>
            <Route exact path={`${match.path}`}>
                <GeneralSettings />
            </Route>
            <Route exact path={`${match.path}/ai`}>
                <AISettings />
            </Route>
        </Switch>
    );
};
